import React, { useState, useRef, useEffect } from 'react';
import './ChatModelSelector.css';

const ChatModelSelector = ({ models, selectedModel, onSelect, onNewChat }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const currentModel = models.find(m => m.value === selectedModel) || models[0];

    return (
        <div className="chat-model-selector" ref={dropdownRef}>
            <div className="model-selector-header">
                <button 
                    className="model-selector-button" 
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <img 
                        src={currentModel.icon} 
                        alt={currentModel.label} 
                        className="model-icon"
                    />
                    <span className="model-name">{currentModel.label}</span>
                    <span className="dropdown-arrow">▼</span>
                </button>
                <button 
                    className="new-chat-icon-button" 
                    onClick={onNewChat}
                    title="创建新对话"
                >
                    ➕
                </button>
            </div>

            {isOpen && (
                <div className="model-dropdown-menu">
                    {models.map(model => (
                        <div
                            key={model.value}
                            className={`model-option ${model.value === selectedModel ? 'selected' : ''}`}
                            onClick={() => {
                                onSelect(model.value);
                                setIsOpen(false);
                            }}
                        >
                            <img 
                                src={model.icon} 
                                alt={model.label} 
                                className="model-icon"
                            />
                            <span className="model-name">{model.label}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ChatModelSelector; 